const button = document.getElementById('toggle-search');
const nav = document.getElementById('main-navigation');

// Both elements come from the page header, so they are present on every regular
// page - but not, for instance, on an error page rendered without it.
if (button && nav) {
    button.addEventListener('click', () => nav.classList.toggle('show-search'));
}

// This file only runs for its side effect; the empty export marks it as a module.
export {};
